import {connect} from "react-redux";
import OtherPalletsPage from "./OtherPalletsPage";
import * as InventoryApiActions from "../../actions/InventoryApiActions";
import * as ViewActions from "../../actions/ViewActions";

function mapStateToProps(state) {
  return {
  }
}

export default connect(mapStateToProps, {...InventoryApiActions, ...ViewActions})(OtherPalletsPage);